export default {"src":"/_next/static/media/cart.526a573f.svg","height":21,"width":30,"blurWidth":0,"blurHeight":0};